module.exports = __webpack_public_path__ + "img/2.07c39088.jpg";